import { render, staticRenderFns } from "./PosGold.vue?vue&type=template&id=6a4a1f4b&scoped=true&"
import script from "./PosGold.vue?vue&type=script&lang=js&"
export * from "./PosGold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a1f4b",
  null
  
)

export default component.exports